var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2552 10.0832H13.7452C11.7085 10.0832 11.5514 11.914 12.651 12.9107L18.3493 18.089C19.4489 19.0857 19.2918 20.9165 17.2552 20.9165H13.7452C11.7085 20.9165 11.5514 19.0857 12.651 18.089L18.3493 12.9107C19.4489 11.914 19.2918 10.0832 17.2552 10.0832Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTransactions);
export default __webpack_public_path__ + "static/media/pending-transactions.4bdd2691f890748eb39f84de68daaf4f.svg";
export { ForwardRef as ReactComponent };